// Task reducer -> responsible for managing how the state changes for task behaves


import * as types from '../actions/actions';

const INITIAL_STATE = [
    {
       title: "title",
       description: "desc",
       date: "2017",
       imgsrc: "url",
    },
    {
			title: "title",
			description: "desc",
			date: "2017",
			imgsrc: "url",
    }
  ];


// LOADS THE initialState of the task part of the App
export default (state = INITIAL_STATE, action) => {
  let newState;

  switch (action.type) {
    case types.ADD_TASK: {
      console.log("action in reducer: ", action);
			// Clones everything in current state, merges it with payload and creates a new object and saves it -> newState
      newState = [...state, Object.assign({}, action.task)];
      return newState;
    }
    case types.REMOVE_TASK: {
      // gets array from state and removes item based on passed integer
      newState = [...state];
      newState.splice(action.index, 1);
      return newState;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./client/reducers/task-reducer.js